<div
  class="file-card"
  [class.selected]="selected"
  [class.selection-mode]="isSelectMode"
  [class.not-selectable]="isSelectMode"
  (click)="onCardActivate($event)"
>
  <!-- File Preview -->
  <div class="file-preview">
    <!-- Invisible overlay button for accessibility and keyboard interaction -->
    <button
      type="button"
      class="card-activation-btn"
      (click)="onDetail(); $event.stopPropagation()"
      (keydown.enter)="onDetail(); $event.stopPropagation()"
      (keydown.space)="$event.preventDefault(); onDetail(); $event.stopPropagation()"
    ></button>
    <img *ngIf="isImage" [src]="file.url" [alt]="file.name" class="file-image" />
    <video *ngIf="isVideo">
      <source [src]="file.url" type="video/mp4" />
    </video>
    <div *ngIf="isPdf" class="file-document-placeholder">
      <div class="mx-auto">
        <div class="icon-container">
          <img src="assets/svg/repository/pdf.svg" alt="Pdf" />
        </div>
      </div>
    </div>
    <div *ngIf="isDoc" class="file-document-placeholder">
      <div class="mx-auto">
        <div class="icon-container">
          <img src="assets/svg/repository/doc.svg" alt="Doc" />
        </div>
      </div>
    </div>
    <div *ngIf="isAudio" class="file-audio-placeholder">
      <div class="mx-auto">
        <div class="icon-container">
          <i class="pi pi-microphone text-4xl" style="color: #00205B"></i>
        </div>
      </div>
    </div>
    
    <!-- Selection overlay in select mode -->
    <div class="selection-overlay" *ngIf="isSelectMode && selected">
      <i class="pi pi-check-circle text-3xl text-green-500"></i>
    </div>
    <!-- Actions - conditionally rendered based on mode -->
    <div class="file-actions">
      <!-- Normal mode: Download and Delete actions -->
      <ng-container *ngIf="!isSelectMode">
        <p-button
          *ngIf="canDownload"
          icon="pi pi-download"
          size="small"
          severity="success"
          (onClick)="onDownload(); $event.stopPropagation()"
          pTooltip="Download"
          rounded
        />
      </ng-container>
    </div>
  </div>

  <!-- File Info -->
  <div class="file-info">
    <h6 class="file-name">{{ file.name }}</h6>
    <div class="flex items-center gap-2">
      <p class="file-type">{{ getFileType() }}</p>
      @if (file.size) {
        <span class="file-size-pill">{{ fileSizeLabel() }}</span>
      }
    </div>
  </div>
</div>

<app-repository-show-file-dialog
  [visible]="showDetailFileDialog()"
  [fileType]="detailFileType()"
  (close)="onCloseShowDialog()"
  [fileUrl]="file.url"
  [fileName]="file.name"
/>
